import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl text-left">
      <h1 className="text-3xl font-bold mb-8 text-left">Privacy Policy</h1>

      <div className="prose prose-lg max-w-none text-left">
        <p>Effective Date: March 25th, 2025</p>

        <p className="mt-4">
          We are committed to protecting your privacy and ensuring a safe online experience. This Privacy Policy explains how we collect, use, and safeguard your personal information when you visit our website and purchase digital products.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">1. Information We Collect</h2>
        <p>
          We collect the following types of information when you visit our website and use our services:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>Personal Information:</strong> When you make a purchase or create an account, we may collect personal information, including your name, email address, billing address, and payment details.</li>
          <li><strong>Non-Personal Information:</strong> We may collect non-personal information, such as your IP address, browser type, device information, and browsing activity on our website.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">2. How We Use Your Information</h2>
        <p>We use the information we collect for the following purposes:</p>
        <ul className="list-disc pl-6 mb-4">
          <li>To process your transactions and deliver digital products.</li>
          <li>To improve our website and services, including personalizing content and marketing efforts.</li>
          <li>To communicate with you, including sending updates, promotional materials, or important service-related notifications.</li>
          <li>To protect against fraud, enforce our terms and conditions, and comply with legal obligations.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">3. Payment Processing</h2>
        <p>
          All payment transactions are processed securely through third-party payment processors, such as PayPal, Stripe. We do not store your payment information on our servers. Please review the privacy policy of the payment processor to understand how your payment details are handled.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">4. Data Security</h2>
        <p>
          We use reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of data transmission over the internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">5. Cookies</h2>
        <p>
          Our website uses cookies to enhance your experience. Cookies are small files stored on your device that help us analyze web traffic and remember your preferences. You can control cookie settings through your browser, but please note that disabling cookies may impact the functionality of our site.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">6. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those websites. We encourage you to review the privacy policies of any third-party sites you visit.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">7. Sharing Your Information</h2>
        <p>
          We will not share, sell, or rent your personal information to third parties for marketing purposes without your consent. However, we may share your information in the following circumstances:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>With trusted service providers who assist with operating our website or fulfilling orders, subject to confidentiality agreements.</li>
          <li>To comply with legal obligations, protect our rights, or prevent fraud.</li>
        </ul>

        <h2 className="text-2xl font-bold mt-8 mb-4">8. Your Rights</h2>
        <p>
          You have the right to access, update, or delete your personal information at any time.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">9. Children's Privacy</h2>
        <p>
          Our website is not intended for use by individuals under the age of 13, and we do not knowingly collect personal information from children. If you believe we have inadvertently collected such information, please contact us to have it removed.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">10. Changes to This Privacy Policy</h2>
        <p>
          We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page, and the "Effective Date" will be updated accordingly. Please review this Privacy Policy periodically for updates.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">11. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at:
        </p>
        <p>
          <strong>Email:</strong> <a href="mailto:support@applaunchai.com">support@applaunchai.com</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
